<template>
    <div class="feed-switch flex-1 flex-no-padding no-select">
        <input id="feedSwitch" type="checkbox" v-model="feedSwitch">
        <label for="feedSwitch" class="label-default">
            <div class="feed-switch-overlay flex">
                <div class="switch switch-1 flex-child-center">
                    <i class="fa" :class="'fa-' + switchOneIcon"></i>
                    <p>{{ switchOneText }}</p>
                </div>
                <div class="switch switch-2 flex-child-center">
                    <i class="fa" :class="'fa-' + switchTwoIcon"></i>
                    <p>{{ switchTwoText }}</p>
                </div>
            </div>
        </label>
    </div>
</template>

<script>
    import FeedSwitch from '../mixins/FeedSwitch.js'

    export default {
        mixins: [FeedSwitch],
        name: 'FeedSwitch',
    }
</script>

<style lang="scss">

</style>